export enum EXPENSES_TYPE {
    FOOD = 'FOOD',
    NON_FOOD = 'NON_FOOD'
}
